import React from "react";

import { CalendarEventBody, CalendarEventTime, CalendarEventTitle } from "./CalendarEvent";

import "./styles.scss";

export const BusyEvent = ({ details, endTime, position, startTime }) => {
  return (
    <CalendarEventBody className="PatientSession__body" details={[details]} position={position}>
      <CalendarEventTitle className="PatientSession__title" title="Busy" />
      <CalendarEventTime endTime={endTime} startTime={startTime} />
    </CalendarEventBody>
  );
};
